

















































import {Component, Prop} from 'vue-property-decorator';
import {validationMixin} from 'vuelidate';
import {mixins} from 'vue-class-component';
import Validation from './Validation';
import ValidationMessagesMixin from '@/app/common/util/ValidationMessagesMixin';
import ILoginForm from '@/app/auth/login/ILoginForm';

@Component({name: 'LoginForm', mixins: [Validation, validationMixin]})
export default class LoginForm extends mixins(ValidationMessagesMixin) {
  @Prop()
  public readonly canRegister!: boolean;
  @Prop()
  public readonly hasLicense!: boolean;
  public loginApi: ILoginForm = {email: '', password: ''};

  public onLogin() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$emit('login', this.loginApi);
    }
  }
}
